import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { useNavigate, useParams } from "react-router-dom";
import jsPDF from "jspdf";
import logo from './vdc_logo.png';
import autoTable from "jspdf-autotable";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Edit_AccountCheckZMCMConveyance = () => {
    const { id, month } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem("authToken");
    const [details, setDetails] = useState([]);
    const [visitRows, setVisitRows] = useState([]);
    const [message, setMessage] = useState("");
    const [accountStatus, setAccountStatus] = useState("PENDING");
    const [empCode, setEmpCode] = useState("");
    const [employeeDetails, setEmployeeDetails] = useState(null);
    const [empRemarks, setEmpRemarks] = useState("");
    const [totalAmount, setTotalAmount] = useState(0);
    const [accountApprovedAmount, setAccountApprovedAmount] = useState("");
    const [auditapprovedate, setAuditApprovedDate] = useState("");
    const [auditapproveamount, setAuditApprovedAmount] = useState("");
    const [accountapprovedate, setAccountApprovedDate] = useState("");
    const [auditmanager, setAuditManager] = useState("");
    const [accountmanager, setAccountManager] = useState("");

    const [profile, setProfile] = useState(null);
    // const [rows, setRows] = useState([]);
    // const [loading, setLoading] = useState(true);
    // const [accountRemarks, setAccountRemarks] = useState("");
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [accountRemarks, setAccountRemarks] = useState("");
    const [auditSummary, setAuditSummary] = useState(null);



    /* ================= PROFILE ================= */
    useEffect(() => {
        fetch(`${API_BASE_URL}profile`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(d => {
                if (d.status && d.profile) {
                    setProfile(d.profile);

                    // ✅ CALL fetchDetails here
                    fetchDetails(d.profile.emp_code);
                }
            })
            .catch(err => {
                console.error("Failed to load profile", err);
            });
    }, []);


    const fetchDetails = async (empCode) => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${API_BASE_URL}getcmzmdetails/${empCode}`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });

            const result = await response.json();

            if (result.status && result.data.status === "success") {
                const row = result.data.data[0];
                setDetails([row]);

                const branchArray = row.branches_list || [];
                const role = row.role;

                // 🔹 Decide visits per branch based on role
                const visitsPerBranch =
                    role === "cluster_manager" ? 2 : 1;

                // 🔹 Total visits
                const totalVisits = branchArray.length * visitsPerBranch;

                // 🔹 Amount split
                const totalAmount = parseFloat(row.amount);
                setTotalAmount(totalAmount);
                const perVisitAmount = totalAmount / totalVisits;
                const displayAmount = Number(perVisitAmount).toFixed(2);
                const visits = [];

                branchArray.forEach((b) => {
                    for (let visitNo = 1; visitNo <= visitsPerBranch; visitNo++) {
                        visits.push({
                            visit_no: visitNo,
                            branch_id: b.id,
                            branch_name: b.name,
                            date: "",
                            from_time: "",
                            to_time: "",
                            day: "",
                            purpose: "",
                            remarks: "",
                            amount: 0,
                            attachment: null,
                        });
                    }
                });

                setVisitRows(visits);
            } else {
                setMessage(result.data?.message || "No conveyance records found");
            }
        } catch (err) {
            setMessage("Failed to load conveyance details");
        } finally {
            setLoading(false);
        }
    };

    /* ================= LOAD DATA ================= */
    useEffect(() => {
        loadPunches();
    }, [month]);

    const loadPunches = async () => {
        try {
            const res = await fetch(`${API_BASE_URL}get_punch_times_for_audit`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ id, month })
            });

            const result = await res.json();

            if (!result.status || !Array.isArray(result.data)) {
                setRows([]);
                setLoading(false);
                return;
            }

            setAuditSummary(result.data[0]);

            const apiAccountStatus = result.data[0]?.account_status || "Pending";
            const emp_code = result.data[0]?.emp_code;

            // ✅ SET EMP CODE
            setEmpCode(emp_code);
            setAccountStatus(apiAccountStatus);
            setAccountRemarks(result.data[0]?.account_remarks || "");
            setEmpRemarks(result.data[0]?.emp_remarks || "");
            setAuditApprovedDate(result.data[0]?.audit_approved_date || "");
            setAuditApprovedAmount(result.data[0]?.audit_approved_amount || "");
            setAccountApprovedDate(result.data[0]?.account_approved_date || "");
            setAuditManager(result.data[0]?.audit_manager || "");
            setAccountManager(result.data[0]?.account_manager || "");

            const formattedRows = result.data.map(r => ({
                id: r.id,
                Punch_date: r.Punch_date,
                Branch: r.Branch,
                Device: r.Device,
                PunchTimes: r.PunchTimes,
                from: r.From_Time ? r.From_Time.substring(0, 5) : "",
                to: r.To_Time ? r.To_Time.substring(0, 5) : "",
                audit_amount: r.audit_amount || "",
                remarks: r.Remarks || "",
                reason: r.Reason_For_Others || "",
                entryType: r.EntryType || "punch",   // ✅ VERY IMPORTANT
                attachment: r.attachment || null
            }));

            setRows(formattedRows);
            setLoading(false);

        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };

    const fetchEmployeeDetails = async (code) => {
        try {
            const response = await fetch(
                `${API_BASE_URL}getemployeedetails/${code}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            const result = await response.json();

            if (result.status) {
                setEmployeeDetails(result.data);
            }

        } catch (err) {
            console.error("Employee fetch error", err);
        }
    };


    useEffect(() => {
        if (empCode) {
            fetchEmployeeDetails(empCode);
        }
    }, [empCode]);

    const updateField = (row, field, value) => {
        setRows(prev =>
            prev.map(r =>
                r.Device === row.Device && r.Punch_date === row.Punch_date
                    ? { ...r, [field]: value }
                    : r
            )
        );
    };

    const calcDuration = (f, t) => {
        if (!f || !t) return "";
        const [fh, fm] = f.split(":").map(Number);
        const [th, tm] = t.split(":").map(Number);
        const diff = (th * 60 + tm) - (fh * 60 + fm);
        return diff > 0 ? `${Math.floor(diff / 60)}h ${diff % 60}m` : "";
    };

    const handleAccountAction = async (status) => {
        const payload = {
            id: id,
            account_status: status,
            account_remarks: accountRemarks,
            account_approved_amount: auditSummary?.audit_approved_amount
        };

        try {
            const res = await fetch(`${API_BASE_URL}update_account_status`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            const result = await res.json();

            if (result.status) {
                toast.success(
                    status === "Approved"
                        ? "Approved successfully"
                        : "Rejected successfully"
                );

                setTimeout(() => navigate("/finance_cmzmconveyance"), 800);
            } else {
                toast.error(result.message || "Action failed");
            }

        } catch (error) {
            console.error(error);
            toast.error("Server error");
        }
    };


    if (loading) return <h3 style={{ padding: 20 }}>Loading...</h3>;

    // ✅ Branches from top section (for V1/V2 logic)
    const topSectionBranches = new Set(
        details[0]?.branches_list?.map(b => b.name) || []
    );

    // ✅ Visit counter (resets every render – correct)
    const branchVisitCounter = {};

    const getDateRangeFromRows = () => {
        if (!rows || rows.length === 0) {
            return { firstDate: "-", lastDate: "-" };
        }

        // convert to Date objects
        const validDates = rows
            .map(r => r.Punch_date)
            .filter(Boolean)
            .map(d => new Date(d));

        if (validDates.length === 0) {
            return { firstDate: "-", lastDate: "-" };
        }

        const minDate = new Date(Math.min(...validDates));
        const maxDate = new Date(Math.max(...validDates));

        const format = (dt) =>
            dt.toLocaleDateString("en-GB"); // dd/mm/yyyy

        return {
            firstDate: format(minDate),
            lastDate: format(maxDate)
        };
    };




    const generatePDF = async () => {

        const doc = new jsPDF();
        const { firstDate, lastDate } = getDateRangeFromRows();

        /* ================= LOGO ================= */


        doc.addImage(logo, 'PNG', 5, 10, 15, 15);  // X, Y, Width, Height

        /* ================= HEADING ================= */
        doc.setFontSize(18);
        doc.setFont("helvetica", "bold");
        doc.text("Fixed Conveyance", 105, 20, { align: "center" });

        doc.setFontSize(11);
        doc.setFont("helvetica", "normal");

        /* ================= EMPLOYEE DETAILS ================= */

        const emp = employeeDetails || {};
        // const row = details[0] || {};
        const row = auditSummary || {};

        const createdOn = row.detail_created_on || "-";

        doc.text(`Employee Name : ${emp.comp_name || "-"}`, 14, 40);
        doc.text(`Employee No   : ${emp.emp_code || "-"}`, 14, 48);
        doc.text(`Department    : ${emp.dept_name || "-"}`, 14, 56);
        doc.text(`Location      : ${emp.location_name || "-"}`, 14, 64);
        doc.text(`Created On    : ${createdOn}`, 14, 72);

        /* ================= SUMMARY TABLE ================= */

        const tableData = [
           ["Month", new Date(month + "-01").toLocaleDateString("en-US", { month: "long", year: "numeric" })],
            ["First Date", firstDate],
            ["Last Date", lastDate],
            ["Audit Status", row.audit_status || "-"],
            ["Finance Status", row.account_status || "-"],
            ["Audit Approved Date", auditapprovedate || "-"],
            ["Audit Approved Amount", auditapproveamount || "-"],
            ["Finance Approved Date", accountapprovedate || "-"],
            ["Audit Manager", auditmanager || "-"],
            ["Finance Manager", accountmanager || "-"],
            ["UTR", row.utr || "-"],
            ["UTR Date", row.utr_date || "-"]
        ];


        autoTable(doc, {
            startY: 85,
            head: [["Field", "Value"]],
            body: tableData,
            theme: "grid",
            styles: {
                fontSize: 10
            },
            headStyles: {
                fillColor: [76, 73, 172] // VDC purple
            }
        });

        /* ================= DOWNLOAD ================= */

        doc.save(`Fixed_Conveyance_${emp.emp_code || "Report"}.pdf`);
    };


    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ background: "#f4f7fb", fontSize: '12px' }}>
            <Header />
            <Sidebar />

            <div className="content-wrapper" style={{ padding: "25px" }}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px"
                }}>
                    <h2 style={{
                        color: "#6ca0dc",
                        fontWeight: "800",
                        fontSize: "24px"
                    }}>
                        Fixed Conveyance - Finance
                    </h2>

                    <button
                        onClick={generatePDF}
                        style={{
                            background: "#16a34a",
                            color: "#fff",
                            border: "none",
                            padding: "10px 18px",
                            borderRadius: "8px",
                            fontWeight: "600",
                            cursor: "pointer"
                        }}
                    >
                        📄 Generate PDF
                    </button>
                </div>


                {/* EMPLOYEE INFO */}
                {profile && details.length > 0 && (
                    <div
                        style={{
                            background: "#ffffffee",
                            padding: "18px 22px",
                            borderRadius: "12px",
                            border: "1px solid #d9e3f1",
                            boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                            marginBottom: "25px"
                        }}
                    >
                        {details.map((row, idx) => (
                            <div key={idx}>
                                {/* ===== Top Row ===== */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                        gap: "30px",
                                        marginBottom: "10px",
                                        paddingBottom: "10px",
                                        borderBottom: "1px dashed #dbe3ef",
                                        fontSize: "14px",
                                        color: "#425b70",
                                    }}
                                >
                                    <span>
                                        <b>Employee:</b> ({empCode})
                                    </span>

                                    <span>
                                        <b>Selected Month:</b> {month}
                                    </span>

                                    <span>
                                        <b>Role:</b> {row.role}
                                    </span>

                                    <span>
                                        <b>Total Branches:</b> {row["1_30_cnt"]}
                                    </span>
                                </div>

                                {/* ===== Branches Row ===== */}
                                <div
                                    style={{
                                        fontSize: "14px",
                                        color: "#425b70",
                                        lineHeight: "1.6",
                                    }}
                                >
                                    <b>Branches:</b>{" "}
                                    {row.branches_list && row.branches_list.length > 0
                                        ? row.branches_list
                                            .slice() // avoid mutating original array
                                            .sort((a, b) => a.name.localeCompare(b.name)) // 🔤 alphabetical sort
                                            .map(b => b.name)
                                            .join(", ")
                                        : "N/A"}
                                </div>
                            </div>
                        ))}
                    </div>
                )}


                {/* TABLE CARD */}
                <div style={cardStyle}>
                    <div style={{ ...tableScrollWrapper, padding: "10px" }}>
                        {/* <h3 style={{ marginBottom: 15, color: "#1e3a8a" }}>🕒 Punch Details</h3> */}

                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={thStyle}>Date</th>
                                    <th style={thStyle}>Branch</th>
                                    {/* <th style={thStyle}>Device</th> */}
                                    <th style={thStyle}>Punch Times</th>
                                    <th style={thStyle}>From</th>
                                    <th style={thStyle}>To</th>
                                    <th style={thStyle}>Duration</th>
                                    <th style={thStyle}>Amount</th>
                                    <th style={thStyle}>Remarks</th>
                                    {/* <th style={thStyle}>Reason</th> */}
                                    <th style={thStyle}>Attachment</th>
                                </tr>
                            </thead>

                            <tbody>
                                {rows.map((row, i) => (
                                    <tr key={i} style={{ background: i % 2 === 0 ? "#fafafa" : "#fff" }}>
                                        <td style={tdStyle}>{row.Punch_date}</td>
                                        <td style={tdStyle}>
                                            {(() => {
                                                const branchName = row.Branch || "";

                                                // ❌ Others → no V1/V2
                                                if (row.entryType === "others") {
                                                    return (
                                                        <span style={{ fontWeight: "600", color: "#374151" }}>
                                                            {branchName}
                                                        </span>
                                                    );
                                                }

                                                // ✅ Apply V1/V2 ONLY if branch exists in top section
                                                if (topSectionBranches.has(branchName)) {
                                                    if (!branchVisitCounter[branchName]) {
                                                        branchVisitCounter[branchName] = 1;
                                                    } else {
                                                        branchVisitCounter[branchName] += 1;
                                                    }

                                                    const visitLabel = `V${branchVisitCounter[branchName]}`;

                                                    return (
                                                        <span style={{ fontWeight: "600", color: "#374151" }}>
                                                            {branchName}{" "}
                                                            <span
                                                                style={{
                                                                    background: "#e0edff",
                                                                    color: "#2563eb",
                                                                    padding: "2px 6px",
                                                                    borderRadius: "6px",
                                                                    fontSize: "11px",
                                                                    fontWeight: "700",
                                                                    marginLeft: "4px"
                                                                }}
                                                            >
                                                                {visitLabel}
                                                            </span>
                                                        </span>
                                                    );
                                                }

                                                // ❌ Not in top section → plain display
                                                return (
                                                    <span style={{ fontWeight: "600", color: "#374151" }}>
                                                        {branchName}
                                                    </span>
                                                );
                                            })()}
                                        </td>

                                        {/* <td style={tdStyle}>{row.Device}</td> */}
                                        <td style={tdStyle}>
                                            {row.PunchTimes && row.PunchTimes.trim() !== "" ? row.PunchTimes : "No"}
                                        </td>
                                        <td style={tdStyle}>
                                            {row.entryType === "others" ? (
                                                <input
                                                    type="time"
                                                    style={inputStyle}
                                                    value={row.from || ""}
                                                    disabled
                                                />
                                            ) : (
                                                <select style={selectStyle} value={row.from} disabled>
                                                    <option value="">Select</option>
                                                    {row.PunchTimes?.split(",").map(p => (
                                                        <option key={p} value={p.trim()}>{p.trim()}</option>
                                                    ))}
                                                </select>
                                            )}
                                        </td>
                                        <td style={tdStyle}>
                                            {row.entryType === "others" ? (
                                                <input
                                                    type="time"
                                                    style={inputStyle}
                                                    value={row.to || ""}
                                                    disabled
                                                />
                                            ) : (
                                                <select style={selectStyle} value={row.to} disabled>
                                                    <option value="">Select</option>
                                                    {row.PunchTimes?.split(",").map(p => (
                                                        <option key={p} value={p.trim()}>{p.trim()}</option>
                                                    ))}
                                                </select>
                                            )}
                                        </td>
                                        <td style={tdStyle}>{calcDuration(row.from, row.to)}</td>
                                        <td style={tdStyle}>{(row.audit_amount)}</td>
                                        <td style={tdStyle}>
                                            <textarea
                                                style={{ ...inputStyle, resize: "none" }} disabled
                                                rows={1}
                                                value={row.remarks || ""}
                                                onChange={(e) => updateField(row, "remarks", e.target.value)}
                                            />
                                        </td>
                                        {/* <td style={tdStyle}>
                                            {row.entryType === "others" ? (
                                                <textarea
                                                    style={{ ...inputStyle, resize: "none" }} disabled
                                                    rows={1}
                                                    value={row.reason || ""}
                                                    onChange={(e) => updateField(row, "reason", e.target.value)}
                                                />
                                            ) : (
                                                "-"
                                            )}
                                        </td> */}
                                        <td style={tdStyle}>
                                            {row.attachment ? (
                                                <a
                                                    href={`${API_BASE_URL.replace("/api/", "")}/uploads/punch_attachments/${row.attachment}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        color: "#2563eb",
                                                        fontWeight: "600",
                                                        textDecoration: "none"
                                                    }}
                                                >
                                                    📎 View
                                                </a>
                                            ) : (
                                                <span style={{ color: "#9ca3af" }}>No File</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style={{ ...profileBox, marginTop: "10px" }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "14px"
                        }}
                    >
                        {empRemarks && (
                            <div
                                style={{
                                    ...profileBox,
                                    marginTop: "10px",
                                    alignContent: "center",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px"
                                }}
                            >
                                <label style={{ fontWeight: "600" }}>Emp Remarks:</label>

                                <textarea
                                    value={empRemarks}
                                    rows={2}
                                    disabled
                                    style={{
                                        padding: "10px 14px",
                                        fontSize: "14px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                        width: "300px",
                                        minHeight: "42px",
                                        resize: "vertical"
                                    }}
                                />
                            </div>
                        )}
                        {/* ================= AUDIT SECTION ================= */}
                        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>

                            <div>
                                <label style={{ fontWeight: "600" }}>Audit Status:</label>
                                <input
                                    value={auditSummary?.audit_status || "-"}
                                    disabled
                                    style={inputStyle}
                                />
                            </div>

                            <div>
                                <label style={{ fontWeight: "600" }}>Audit Approved Amount:</label>
                                <input
                                    value={auditSummary?.audit_approved_amount || "-"}
                                    disabled
                                    style={inputStyle}
                                />
                            </div>

                            <div style={{ flex: 1 }}>
                                <label style={{ fontWeight: "600" }}>Audit Remarks:</label>
                                <textarea
                                    value={auditSummary?.audit_remarks || ""}
                                    disabled
                                    rows={1}
                                    style={{ ...inputStyle, resize: "none" }}
                                />
                            </div>
                        </div>

                        {/* ================= ACCOUNT SECTION ================= */}
                        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>

                            <div>
                                <label style={{ fontWeight: "600" }}>Finance Status:</label>
                                <select
                                    value={accountStatus}
                                    onChange={(e) => setAccountStatus(e.target.value)}
                                    style={inputStyle}
                                >
                                    <option value="Pending">Pending</option>
                                    <option value="Approved">Approved</option>
                                    <option value="Rejected">Rejected</option>
                                </select>
                            </div>

                            {/* <div>
        <label style={{ fontWeight: "600" }}>Account Approved Amount:</label>
        <input
            type="number"
            value={accountApprovedAmount}
            onChange={(e) => setAccountApprovedAmount(e.target.value)}
            placeholder="Enter approved amount"
            style={inputStyle}
        />
    </div> */}

                            <div style={{ flex: 1 }}>
                                <label style={{ fontWeight: "600" }}>Finance Remarks:</label>
                                <textarea
                                    value={accountRemarks}
                                    onChange={(e) => setAccountRemarks(e.target.value)}
                                    rows={1}
                                    style={{ ...inputStyle, resize: "none" }}
                                />
                            </div>

                        </div>

                    </div>
                </div>


                {/* ACTION BUTTONS */}
                <div style={actionBar}>
                    <button
                        onClick={() => navigate("/finance_cmzmconveyance")}
                        style={{ ...buttonBase, background: "#6b7280" }}
                    >
                        ❌ Cancel
                    </button>

                    <button
                        onClick={() => handleAccountAction(accountStatus)}
                        style={{ ...buttonBase, background: "#2563eb" }}
                    >
                        ✅ Update Status
                    </button>
                </div>
            </div>

            <Footer />
        </div>
    );
};

/* ================= STYLES ================= */

const tableScrollWrapper = {
    maxHeight: "60vh",      // controls scroll height
    overflowY: "auto",
    border: "1px solid #e5e7eb",
    borderRadius: "10px"
};


const profileBox = {
    background: "#ffffff",
    padding: "15px 20px",
    borderRadius: "12px",
    marginBottom: "20px",
    border: "1px solid #e5e7eb",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
};

const cardStyle = {
    background: "#fff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)"
};

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px"
};

const thStyle = {
    padding: "10px",
    background: "#f8fafc",
    borderBottom: "2px solid #e5e7eb",
    fontWeight: 600
};

const tdStyle = {
    padding: "8px",
    borderBottom: "1px solid #e5e7eb",
    fontSize: "13px"
};

const inputStyle = {
    width: "100%",
    padding: "6px 8px",
    borderRadius: "6px",
    border: "1px solid #cbd5e1"
};

const selectStyle = {
    ...inputStyle,
    cursor: "pointer"
};

const buttonBase = {
    padding: "12px 36px",
    fontSize: "15px",
    borderRadius: "10px",
    border: "none",
    fontWeight: "700",
    color: "#fff",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
};

const actionBar = {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginTop: "25px"
};

export default Edit_AccountCheckZMCMConveyance;
